import { CertificateStatus, CertificateType, TargetSystem } from '../../types/apiRequests'

export interface TargetSystemCapabilities {
  // 'manual': user enters metaData.commonName; 'derived': the system's own form sets it.
  commonName: 'manual' | 'derived'
  allowedTypes: CertificateType[]
  // Certificate can be installed (scheduled/now) into the target system.
  installable: boolean
}

// Mirrors the API's target system registry (GET /target-systems).
// Record over the enum: a new TargetSystem without an entry fails tsc.
export const TARGET_SYSTEMS: Record<TargetSystem, TargetSystemCapabilities> = {
  [TargetSystem.ZAKEN]: {
    commonName: 'derived',
    allowedTypes: [CertificateType.Pki, CertificateType.ZaakClient],
    installable: true,
  },
  [TargetSystem.KOPPELEN]: {
    commonName: 'manual',
    allowedTypes: [CertificateType.Pki],
    installable: false,
  },
  [TargetSystem.BEZWAREN]: {
    commonName: 'manual',
    allowedTypes: [CertificateType.Pki],
    installable: false,
  },
}

export const getCapabilities = (targetSystem?: TargetSystem | null): TargetSystemCapabilities | undefined =>
  // eslint-disable-next-line security/detect-object-injection
  targetSystem ? TARGET_SYSTEMS[targetSystem] : undefined

// Statuses before the CSR left the system: a downloaded CSR keeps the old hostname.
export const COMMON_NAME_EDITABLE_STATUSES: CertificateStatus[] = [
  CertificateStatus.PENDING,
  CertificateStatus.CSR_READY,
]
